import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {RetarderConfiguration} from './types'

export const buildRetarderConfiguration = ({
  options: {
    constraints: {retarder}
  }
}: BuildConfigurationInput): RetarderConfiguration => {
  return {
    retarder: retarder ?? {isEnabled: false}
  }
}
